module.exports = {
  "/myaccounts": {
    "success": {
      "index page loaded with table": [
        "INDEX_LOAD",
        "TABLE_LOAD"
      ],
      "index page load with empty table": [
        "INDEX_LOAD",
        "EMPTY_TABLE_LOAD"
      ]
    }
  },
  "/myaccounts-beta": {}
};